import { render } from "./WebkassaIntegration.vue?vue&type=template&id=7eff59d2"
import script from "./WebkassaIntegration.vue?vue&type=script&lang=js"
export * from "./WebkassaIntegration.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__